
(ns app.strive-forms.question-fields.dropdown-field
  (:require-macros [reagent-mui.util :refer [react-component]])
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?
                                                              update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [component-alignment
                                                       scroll-to-next-required-field!]]
            [app.strive-forms.styles :refer [dropdown-field-wrapper-style
                                             list-group-item-style
                                             list-group-item-text-style]]
            [re-com.core :as re-com :refer [v-box]]
            [re-frame.core :as re-frame]
            [reagent-mui.material.autocomplete :refer [autocomplete] :rename {autocomplete mui-autocomplete}]
            [reagent-mui.material.list :refer [list]]
            [reagent-mui.material.list-item-button :refer [list-item-button]]
            [reagent-mui.material.list-item-text :refer [list-item-text]]
            [reagent-mui.material.text-field :refer [text-field]]
            [reagent.core :as r]))

(defn- border-size-for-list-item [{:keys [selections item]}]
  (if (some #(= % item) @selections) "2px solid " "1px solid "))

(defn- border-color-for-list-item [{:keys [selections item theme-data]}]
  (if (some #(= % item) @selections) (:buttons_color theme-data) (:answers_border_color theme-data "#9c9ea8")))

(defmethod update-question-input-local "dropdown" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))


(defmethod update-question-input-data "dropdown" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

(defn- process-response! [{:keys [input-data field-id regenerate-display-fields selections allow-multiple? missing-required-fields
                                  current-page is-multi-question? steps-total]}]
  (if allow-multiple?
    (do
      (update-question-input-local {:field-id field-id
                                    :input-data input-data
                                    :type "dropdown"
                                    :input-value selections})
      (regenerate-display-fields
       (update input-data (keyword field-id) (fn [value]
                                               (assoc value
                                                      :value selections)))))
    (do (re-frame/dispatch [::sfevents/update-input-local
                            {:input-data input-data :key (keyword field-id) :value selections}])
        (regenerate-display-fields
         (update input-data (keyword field-id) (fn [value]
                                                 (assoc value
                                                        :value selections))))
        (when-not (zero? (count @missing-required-fields))

          (scroll-to-next-required-field! {:missing-required-fields missing-required-fields :field-id field-id
                                           :current-page current-page :is-multi-question? is-multi-question?
                                           :steps-total steps-total})))))

(defn map-dropdown-options [{:keys [data]}]
  (map  #(-> %
             (assoc :label (% :value))) data))

(defmethod show-action-btn? "dropdown" []
  true)

(defn select-values-from-bar! [{:keys [selected-values options-list allow-multi?]}]
  (let [options-selected (js->clj options-list :keywordize-keys true)]
    (reset! selected-values
          (if allow-multi?
            (map (fn [value]
                   value)
                 options-selected)
            (list (:value options-selected))))))

(defn- on-change-from-bar! [{:keys [selected-values settings input-data field-id regenerate-display-fields 
                                    missing-required-fields current-page is-multi-question? steps-total]}]

  (fn [event options-list]
    (select-values-from-bar! {:selected-values selected-values
                          :options-list options-list
                          :allow-multi? (:allow_multi settings)})
    (process-response! {:input-data input-data :field-id field-id
                        :regenerate-display-fields regenerate-display-fields
                        :selections @selected-values
                        :allow-multiple? (:allow_multi settings)
                        :missing-required-fields missing-required-fields
                        :current-page current-page :is-multi-question? is-multi-question?
                        :steps-total steps-total})))

(defn- list-contains-value? [{:keys [value selected-values]}]
  (some #(= % value) @selected-values))

(defn- multi-select! [{:keys [value selected-values]}]
  (if (list-contains-value? {:value value :selected-values selected-values})
    (vec (remove #(= % value) @selected-values))
    (conj @selected-values value)))

(defn- single-select! [{:keys [value selected-values]}]
  (if (some #(= % value) @selected-values)
    []
    (conj [] value)))

(defn- select-values! [{:keys [selected-values allow-multi? value]}]
  (reset! selected-values
          (if allow-multi?
            (multi-select! {:value value :selected-values selected-values})
            (single-select! {:value value :selected-values selected-values}))))

(defn- multi-table-on-change! [{:keys [selected-values settings input-data field-id regenerate-display-fields input-value
                                       button-ids-for-button missing-required-fields current-page is-multi-question? steps-total
                                       value]}]
  (select-values! {:selected-values selected-values
                   :allow-multi? (:allow_multi settings)
                   :value value})
  (process-response! {:input-data input-data :field-id field-id
                      :regenerate-display-fields regenerate-display-fields
                      :selections @selected-values
                      :input-value input-value
                      :allow-multiple? (:allow_multi settings)
                      :button-ids-for-button button-ids-for-button
                      :missing-required-fields missing-required-fields
                      :current-page current-page :is-multi-question? is-multi-question?
                      :steps-total steps-total}))

(defn get-dropdown-options [{:keys [data alpha-order?]}]
  (cond->> (map-dropdown-options {:data data})
    alpha-order? (sort-by :label)))

(defn- dropdown-items-table [{:keys [selected-values settings input-data field-id regenerate-display-fields
                                     missing-required-fields current-page is-multi-question? steps-total theme-data language-direction item
                                     selected-language]}]
  (let [item-value (get (:option-texts item) (keyword selected-language))]
    [list-item-button  {:role "undefined"
                        :disableRipple true
                        :dense true
                        :onClick (fn []
                                   (multi-table-on-change! {:selected-values selected-values :settings settings :input-data input-data :field-id field-id
                                                            :regenerate-display-fields regenerate-display-fields :missing-required-fields missing-required-fields
                                                            :current-page current-page :is-multi-question? is-multi-question? :steps-total steps-total
                                                            :value item-value}))
                        :class (list-group-item-style  {:width (:dropdown-item (:field-inputs-width default-values))
                                                        :background-color (str (:answers_background_color theme-data) "60")
                                                        :border-color (border-color-for-list-item {:selections selected-values :item item-value
                                                                                                   :theme-data theme-data})
                                                        :answer-color (:answers_color theme-data)
                                                        :border-size (border-size-for-list-item {:selections selected-values
                                                                                                 :item item-value})
                                                        :text-align (if (= language-direction "RTL") "right" "left")
                                                        :margin "8px 0"})}
     [list-item-text {:id (str "labelId" (:id item))
                      :key (str "labelId" (:id item))
                      :primary item-value
                      :class (list-group-item-text-style {:answer-color (:answers_color theme-data)})}]]))

(defn- mui-autocomplete-field [{:keys [settings dropdown-options selected-values field-id regenerate-display-fields missing-required-fields
                                       current-page input-data is-multi-question? steps-total theme-data selected-language language-direction]}]
  [:div [mui-autocomplete {:id            "autocomplete-input"
                           :class (dropdown-field-wrapper-style)
                           :multiple (:allow_multi settings)
                           :freeSolo true ;;TODO: implyOther (when we implement it)
                           :options       @dropdown-options
                           :value (or @selected-values nil)
                           :default-value @selected-values
                           :on-change     (on-change-from-bar! {:selected-values selected-values :settings settings :input-data input-data :field-id field-id
                                                                :regenerate-display-fields regenerate-display-fields :missing-required-fields missing-required-fields
                                                                :current-page current-page :is-multi-question? is-multi-question? :steps-total steps-total})


                           :render-input  (react-component [props]
                                                           [text-field (merge props
                                                                              {:label "Autocomplete"})])
                           :render-option (react-component [props item]
                                                           [dropdown-items-table {:selected-values selected-values :settings settings :input-data input-data :field-id field-id
                                                                                  :regenerate-display-fields regenerate-display-fields :missing-required-fields missing-required-fields
                                                                                  :current-page current-page :is-multi-question? is-multi-question? :steps-total steps-total
                                                                                  :theme-data theme-data :language-direction language-direction :item item
                                                                                  :selected-language selected-language}])}]])

(defn dropdown-field [{:keys [field field-id input-data regenerate-display-fields]}]
  (let [text-val (r/atom (:value (get input-data (keyword field-id))))
        settings (merge
                  (select-keys (:additional_settings field) [:allow_multi :count_range :imply_other :alpha_order])
                  {:is_required (:is_required field)})
        dropdown-options (r/atom (get-dropdown-options {:data (:multi_select_items field)
                                                        :alpha-order? (:alpha_order settings)}))
        selected-values (r/atom (vec (:value (get input-data (keyword field-id)))))]
    ;TODO: default value
    (fn [{:keys [field-id current-page input-data theme-data selected-language language-direction 
                 missing-required-fields is-multi-question? steps-total]}]
      [v-box
       :width "100%"
       :justify :center
       :align (component-alignment is-multi-question?)
       :children [[mui-autocomplete-field {:settings settings :dropdown-options dropdown-options :selected-values selected-values
                                           :input-data input-data :field-id field-id :regenerate-display-fields regenerate-display-fields
                                           :missing-required-fields missing-required-fields :current-page current-page
                                           :is-multi-question? is-multi-question? :steps-total steps-total
                                           :theme-data theme-data :selected-language selected-language
                                           :language-direction language-direction}]]])))